// react
import React from "react";
// store
import { routes } from "../../store/routes";
// components
import { Button, Icon } from "semantic-ui-react";

// component
const EmptyBasket = () => {
    // template
    return (
        <div className="empty-basket-container">
            <div className="empty-basket-content">
                <div className="empty-basket-icon">
                    <Icon name="shopping basket" size="massive" />
                </div>
                <h2 className="empty-basket-title">Váš košík je prázdny</h2>
                <p className="empty-basket-description">
                    Zatiaľ ste nepridali žiadne aktivity do košíka.
                    <br />
                    Prehľadajte našu ponuku a nájdite aktivity, ktoré vás zaujímajú.
                </p>
                <Button
                    type="button"
                    className="empty-basket-button"
                    as="a"
                    href={routes.SEARCH}
                    size="large"
                    color="green"
                >
                    <Icon name="search" />
                    Pokračovať vo vyhľadávaní
                </Button>
            </div>
        </div>
    );
};

export default EmptyBasket;
